// src/features/project-intake/components/ConditionalFields.tsx

import React from 'react';

interface ConditionalFieldsProps {
  requiresResearch: boolean;
  requiresAcquisition: boolean;
  requiresQaqc: boolean;
  impactedParcels: string;
  researchIsGovOwned: string;
  acquisitionIsGovOwned: string;
  qaHasDocumentation: string;
  onImpactedParcelsChange: (value: string) => void;
  onRadioChange: (name: string, value: string) => void;
}

// Conditional fields that appear based on work request selection
export const ConditionalFields = React.memo<ConditionalFieldsProps>(
  ({
    requiresResearch,
    requiresAcquisition,
    requiresQaqc,
    impactedParcels,
    researchIsGovOwned,
    acquisitionIsGovOwned,
    qaHasDocumentation,
    onImpactedParcelsChange,
    onRadioChange,
  }) => {
    if (!requiresResearch && !requiresAcquisition && !requiresQaqc) {
      return null;
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {requiresResearch && (
          <>
            <div>
              <label className="block text-sm font-medium theme-text-secondary mb-0.5">
                Impacted Parcels <span className="text-red-500">*</span>
              </label>
              <input
                name="impacted_parcels"
                value={impactedParcels}
                onChange={(e) => onImpactedParcelsChange(e.target.value)}
                type="number"
                min="0"
                className="w-full border theme-border rounded px-2 py-1 text-sm theme-card theme-text-primary"
              />
            </div>
            <div>
              <label className="block text-sm font-medium theme-text-secondary mb-0.5">
                Research: Is Government Owned?
              </label>
              <div className="flex gap-3">
                <label className="flex items-center gap-1.5 cursor-pointer theme-text-primary">
                  <input
                    type="radio"
                    name="research_is_government_owned"
                    value="Yes"
                    checked={researchIsGovOwned === 'Yes'}
                    onChange={(e) => onRadioChange('research_is_government_owned', e.target.value)}
                    className="w-3.5 h-3.5 accent-blue-600"
                  />
                  <span className="text-sm">Yes</span>
                </label>
                <label className="flex items-center gap-1.5 cursor-pointer theme-text-primary">
                  <input
                    type="radio"
                    name="research_is_government_owned"
                    value="No"
                    checked={researchIsGovOwned === 'No'}
                    onChange={(e) => onRadioChange('research_is_government_owned', e.target.value)}
                    className="w-3.5 h-3.5 accent-blue-600"
                  />
                  <span className="text-sm">No</span>
                </label>
              </div>
            </div>
          </>
        )}
        {requiresAcquisition && (
          <div>
            <label className="block text-sm font-medium theme-text-secondary mb-0.5">
              Acquisition: Is Government Owned?
            </label>
            <div className="flex gap-3">
              <label className="flex items-center gap-1.5 cursor-pointer theme-text-primary">
                <input
                  type="radio"
                  name="acquisition_is_government_owned"
                  value="Yes"
                  checked={acquisitionIsGovOwned === 'Yes'}
                  onChange={(e) => onRadioChange('acquisition_is_government_owned', e.target.value)}
                  className="w-3.5 h-3.5 accent-blue-600"
                />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center gap-1.5 cursor-pointer theme-text-primary">
                <input
                  type="radio"
                  name="acquisition_is_government_owned"
                  value="No"
                  checked={acquisitionIsGovOwned === 'No'}
                  onChange={(e) => onRadioChange('acquisition_is_government_owned', e.target.value)}
                  className="w-3.5 h-3.5 accent-blue-600"
                />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>
        )}
        {requiresQaqc && (
          <div>
            <label className="block text-sm font-medium theme-text-secondary mb-0.5">
              QA/QC: Do you have the necessary documentation?
            </label>
            <div className="flex gap-3">
              <label className="flex items-center gap-1.5 cursor-pointer theme-text-primary">
                <input
                  type="radio"
                  name="qa_has_documentation"
                  value="Yes"
                  checked={qaHasDocumentation === 'Yes'}
                  onChange={(e) => onRadioChange('qa_has_documentation', e.target.value)}
                  className="w-3.5 h-3.5 accent-blue-600"
                />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center gap-1.5 cursor-pointer theme-text-primary">
                <input
                  type="radio"
                  name="qa_has_documentation"
                  value="No"
                  checked={qaHasDocumentation === 'No'}
                  onChange={(e) => onRadioChange('qa_has_documentation', e.target.value)}
                  className="w-3.5 h-3.5 accent-blue-600"
                />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>
        )}
      </div>
    );
  }
);

ConditionalFields.displayName = 'ConditionalFields';
